/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';

import ModalFull from '@components/modal/ModalFull';
import Table from '@components/table/Table';
import { useSelector, useDispatch } from 'react-redux';
import SociollaText from '@components/sociolla/SociollaText';
import Photo from '@components/global/Photo';

import Colors from '@global/colors';
import { isWeb, fullHeight } from '@global/screens';
import { showPopup } from '@/store/modal';

function VisitDetail(props) {
  const dispatch = useDispatch();
  const showVisitDetail = useSelector((state) => state.modal.visitDetail);
  const showVisitTeamDetail = useSelector(
    (state) => state.modal.visitTeamDetail,
  );

  const showDetail = Boolean(showVisitDetail || showVisitTeamDetail);

  const tableStructure = {
    ...(showVisitDetail
      ? {
          name: {
            head: 'Name',
            body: 'name',
            textStyle: { fontFamily: 'figtree-medium' },
          },
        }
      : {}),
    no_of_visit: {
      head: 'No of Visit',
      body: 'no_of_visit',
    },
    ...(showVisitTeamDetail
      ? {
          customer_name: {
            head: 'Customer Name',
            body: 'customer_name',
          },
        }
      : {}),
    duration_of_visit: {
      head: 'Duration of Visit',
      body: 'duration_of_visit',
      type: showVisitDetail ? 'slot' : 'text',
    },
    ...(showVisitTeamDetail
      ? {
          time_stamp: {
            head: 'Time Stamp',
            body: 'time_stamp',
            type: 'slot',
          },
        }
      : {}),
  };

  let tableData = [
    {
      no_of_visit: 5,
      customer_name: 'Toko Maju Jaya',
      duration_of_visit: '1 hour 15 minutes',
      time_stamp: '',
    },
    {
      no_of_visit: 5,
      customer_name: 'Toko Maju Jaya',
      duration_of_visit: '1 hour 15 minutes',
      time_stamp: '',
    },
    {
      no_of_visit: 5,
      customer_name: 'Toko Maju Jaya',
      duration_of_visit: '1 hour 15 minutes',
      time_stamp: '',
    },
    {
      no_of_visit: 5,
      customer_name: 'Toko Maju Jaya',
      duration_of_visit: '1 hour 15 minutes',
      time_stamp: '',
    },
    {
      no_of_visit: 5,
      customer_name: 'Toko Maju Jaya',
      duration_of_visit: '1 hour 15 minutes',
      time_stamp: '',
    },
    {
      no_of_visit: 5,
      customer_name: 'Toko Maju Jaya',
      duration_of_visit: '1 hour 15 minutes',
      time_stamp: '',
    },
  ];

  if (showVisitDetail) {
    tableData = [
      { name: 'Ogasawara Katsumi', no_of_visit: 5, duration_of_visit: '' },
      { name: 'Ogasawara Katsumi', no_of_visit: 5, duration_of_visit: '' },
      { name: 'Ogasawara Katsumi', no_of_visit: 5, duration_of_visit: '' },
      { name: 'Ogasawara Katsumi', no_of_visit: 5, duration_of_visit: '' },
      { name: 'Ogasawara Katsumi', no_of_visit: 5, duration_of_visit: '' },
      { name: 'Ogasawara Katsumi', no_of_visit: 5, duration_of_visit: '' },
    ];
  }

  return (
    <ModalFull
      show={showDetail}
      title={`${showVisitDetail ? 'Team ' : ''}Customer Visit Detail`}
      width={isWeb ? 650 : '100%'}
      back={!isWeb}
      onClose={() => {
        if (showVisitDetail) {
          dispatch(showPopup({ name: 'visitDetail', value: false }));
        }
        if (showVisitTeamDetail) {
          dispatch(showPopup({ name: 'visitTeamDetail', value: false }));
        }
      }}>
      <ScrollView
        style={[
          { width: '100%', maxHeight: fullHeight - (isWeb ? 110 : 55) },
          !isWeb ? { padding: 15, backgroundColor: Colors.grey0 } : {},
        ]}>
        <View style={styles.wrapper}>
          <SociollaText>18 November 2022 - SDI Branch Jakarta</SociollaText>
          {showVisitTeamDetail ? (
            <View style={styles.teamMemberUser}>
              <Photo
                image={''}
                width={25}
                height={25}
                style={styles.teamMemberPhoto}
              />
              <SociollaText style={styles.teamMemberText}>
                Ogasawara Katsumi
              </SociollaText>
            </View>
          ) : (
            false
          )}
          {isWeb ? (
            <Table
              name="visit-detail"
              structures={tableStructure}
              data={tableData}
              loading={false}
              showSearch={false}
              showFilter={false}
              showPagination={false}
              hasCallback={true}
              hasNoHide={true}
            />
          ) : (
            false
          )}
        </View>
      </ScrollView>
    </ModalFull>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    padding: 15,
  },
  teamMemberUser: {
    width: '100%',
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  teamMemberPhoto: { marginRight: 10 },
  teamMemberText: { fontSize: 13 },
});

export default React.memo(VisitDetail, (prev, next) => prev == next);
